module.exports = __webpack_public_path__ + "static/img/login_loading.4c36de18.gif";